import React, { Component } from 'react';

import "./ArticleSides.scss"
import data from "../../api/data.json"
import { Link } from 'react-router-dom'

class ArticleSides extends Component {
  render() {
    const rightImage = {
      backgroundImage: "url(" + data.SideArticles.right.image + ")"
    }
    const leftImage = {
      backgroundImage: "url(" + data.SideArticles.left.image + ")"
    }
    return (
      <section className="section section-articles">
        <div className="padding">
          <div className="side sideright">
            <div className="image" style={rightImage}></div>
            <div className="desc">
              <div className="padding">
                <h4>{data.SideArticles.right.headline}</h4>
                <h5>{data.SideArticles.right.desc}</h5>
                <div className="button">
                  <Link to={data.SideArticles.right.link}>
                    <div className="label">
                      {data.SideArticles.right.linktext}
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="side sideleft">
          <div className="image" style={leftImage}></div>
          <div className="desc">
            <div className="padding">
              <h4>{data.SideArticles.left.headline}</h4>
              <h5>{data.SideArticles.left.desc}</h5>
              <div className="button">
              <Link to={data.SideArticles.left.link}>
                  <div className="label">
                    {data.SideArticles.left.linktext}
                  </div>
                </Link>
              </div>
            </div>
          </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ArticleSides;



// WEBPACK FOOTER //
// ./src/components/ArticleSides/ArticleSides.js